export default "__VITE_ASSET__DCs1234s__"